let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("81hHt")).then(() => parcelRequire('88gzH'));